
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire80ff"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire80ff"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("c5HCY", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $8cd7cb2f9c6c5d38$export$6503ec6e8aabbaf; }, function (v) { return $8cd7cb2f9c6c5d38$export$6503ec6e8aabbaf = v; });
var $8cd7cb2f9c6c5d38$export$6503ec6e8aabbaf;
var $8cd7cb2f9c6c5d38$export$f7ad0328861e2f03;
"use strict";
var $8cd7cb2f9c6c5d38$var$mapping = new Map();
function $8cd7cb2f9c6c5d38$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$8cd7cb2f9c6c5d38$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $8cd7cb2f9c6c5d38$var$resolve(id) {
    var resolved = $8cd7cb2f9c6c5d38$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$8cd7cb2f9c6c5d38$export$6503ec6e8aabbaf = $8cd7cb2f9c6c5d38$var$register;
$8cd7cb2f9c6c5d38$export$f7ad0328861e2f03 = $8cd7cb2f9c6c5d38$var$resolve;

});

var $652e060980a2940e$exports = {};

(parcelRequire("c5HCY")).register(new URL("", import.meta.url).toString(), JSON.parse('["3xD7K","index.f924a8f9.js","2CvSw","amazon-clone-1.f81ff7da.png","2osXR","amazon-clone-2.7e8cfdef.png","lAhnp","amazon-clone-3.d36b3130.png","6KLeN","collection-1.589c8ce8.png","jAiIW","collection-2.eb129d7f.png","4ln3D","collection-3.2c9ca6b5.png","40KPN","collection-4.54a3593e.png","6nY6t","collection-5.07104752.png","75Ide","countdown-1.45330a81.png","5zAPx","game-hub-1.81df5640.png","bNJmM","game-hub-2.8a0b6f91.png","519qK","game-hub-3.2600e03c.png","6ZN8L","mapty-1.bca65cfd.png","1Tbwx","shoe-sphere-1.8967b12e.png","5AYXT","shoe-sphere-2.edcd0e55.png","asOly","shoe-sphere-3.084fb9d4.png","7ZZCA","shoe-sphere-4.7c3af8a9.png","fLA0q","shoe-sphere-5.58fd8992.png","7Dr7N","shoe-sphere-6.f5195d5c.png"]'));


//# sourceMappingURL=index.runtime.9f676091.js.map
